import React, { useEffect, useState } from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    useTheme,
    MenuItem,
    FormControlLabel,
    Checkbox,
    IconButton,
} from "@mui/material";
import { addFlats, updateFlat } from "state/apis";
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import { Close as CloseIcon } from "@mui/icons-material";

const AddFlatsForm = ({ open, onClose, onSubmit, editData, editMode, property }) => {
    const theme = useTheme();
    const [isFlat, setIsFlat] = useState(false);
    const [isShop, setIsShop] = useState(false);
    const defaultProperty = localStorage.getItem("propertyId");

    const [data, setData] = useState({
        propertyId: defaultProperty || "",
        unitNumber: "",
        floorNumber: "",
        category: "",
        type: "",
        // vacant: false,
        // booked: false,
        description: "",
        area: "",
        noOfBalcony: "",
        noOfBathroom: "",
        noOfDoors: "",
        serialNumber: 0,
    });

    useEffect(() => {
        if (editMode && editData) {
            if (editData.category === "Flat") {
                setIsFlat(true);
                setIsShop(false);
            } else if (editData.category === "Shop" || editData.category === "Warehouse") {
                setIsShop(true);
                setIsFlat(false);
            } else {
                setIsFlat(false);
                setIsShop(false);
            }

            setData((prevData) => ({
                ...prevData,
                propertyId: editData.propertyId,
                unitNumber: editData.unitNumber,
                floorNumber: editData.floorNumber,
                category: editData.category,
                type: editData.type,
                //    vacant: editData.vacant,
                //     booked: editData.booked,
                description: editData.description || "",
                area: editData.area || "",
                noOfBalcony: editData.noOfBalcony || "",
                noOfBathroom: editData.noOfBathroom || "",
                noOfDoors: editData.noOfDoors || "",
                serialNumber: editData.serialNumber || 0,
            }));
        } else {
            setData({
                propertyId: defaultProperty || "",
                unitNumber: "",
                floorNumber: "",
                category: "",
                type: "",
                // vacant: false,
                // booked: false,
                description: "",
                area: "",
                noOfBalcony: "",
                noOfBathroom: "",
                noOfDoors: "",
                serialNumber: 0,
            });
        }
    }, [editData, editMode]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleCategoryChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === "category") {
            setIsFlat(value === "Flat");
            setIsShop(value === "Shop" || value === "Warehouse");
        } else {
            setIsFlat(false);
            setIsShop(false);
        }
    };

    const handlePropertyChange = (newValue) => {
        setData((prevData) => ({
            ...prevData,
            propertyId: newValue ? newValue.id : null,
        }));
    };

    const handleSubmit = async () => {
        try {
            if (editMode) {
                const response = await updateFlat(editData.id, data);
                toast.success(response.message);
            } else {
                const response = await addFlats(data);
                toast.success(response.message);
            }

            onSubmit();
            onClose();
            setIsFlat(false);
            setIsShop(false);
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };
    return (
        <Dialog open={open} onClose={onClose}>
            {/* <DialogTitle sx={{ textAlign: "center", fontWeight: "900", mb: "2px" }}>
                {editMode ? "Edit Unit" : "Add Unit"}
            </DialogTitle> */}
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginLeft: "6px",
                }}
            >
                {editMode ? "Edit Unit" : "Add Unit"}
                <IconButton onClick={onClose} sx={{ color: "inherit" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} p={"5px"}>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Serial Number"
                            name="serialNumber"
                            value={data?.serialNumber}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={property}
                            getOptionLabel={(option) => option.propertyName}
                            // value={
                            //     data.propertyId
                            //         ? property.find((pro) => pro.id === data.propertyId)
                            //         : null
                            // }
                            value={
                                defaultProperty
                                    ? property.find((pro) => pro.id == defaultProperty) || null
                                    : null
                            }
                            onChange={(event, newValue) => handlePropertyChange(newValue)}
                            isOptionEqualToValue={(option, value) => option === value}
                            getOptionDisabled={(option) => option.id != defaultProperty}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.propertyName}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Property" />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Unit Number"
                            name="unitNumber"
                            value={data?.unitNumber}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Floor Number"
                            name="floorNumber"
                            value={data?.floorNumber}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            select
                            color="primary"
                            fullWidth
                            label="Select Category"
                            name="category"
                            value={data.category}
                            onChange={handleCategoryChange}
                        >
                            <MenuItem value="Flat">Flat</MenuItem>
                            <MenuItem value="Shop">Shop</MenuItem>
                            <MenuItem value="Store">Store</MenuItem>
                            <MenuItem value="Shed">Shed</MenuItem>
                            <MenuItem value="Parking">Parking</MenuItem>
                        </TextField>
                    </Grid>
                    {(isFlat || isShop) && (
                        <Grid item xs={12}>
                            <TextField
                                color="primary"
                                fullWidth
                                label="Area"
                                name="area"
                                value={data?.area}
                                onChange={handleChange}
                            />
                        </Grid>
                    )}
                    {isFlat && (
                        <>
                            <Grid item xs={12}>
                                <TextField
                                    color="primary"
                                    fullWidth
                                    label="Number of balcony"
                                    name="noOfBalcony"
                                    value={data?.noOfBalcony}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    color="primary"
                                    fullWidth
                                    label="Number of bathroom"
                                    name="noOfBathroom"
                                    value={data?.noOfBathroom}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </>
                    )}
                    {isShop && (
                        <Grid item xs={12}>
                            <TextField
                                color="primary"
                                fullWidth
                                label="Number of doors"
                                name="noOfDoors"
                                value={data?.noOfDoors}
                                onChange={handleChange}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <TextField
                            select
                            color="primary"
                            fullWidth
                            label="Select Type"
                            name="type"
                            value={data.type}
                            onChange={handleChange}
                        >
                            <MenuItem value="1BHK">1BHK</MenuItem>
                            <MenuItem value="2BHK">2BHK</MenuItem>
                            <MenuItem value="3BHK">3BHK</MenuItem>
                            <MenuItem value="studio">Studio</MenuItem>
                            <MenuItem value="Shop">Shop</MenuItem>
                            <MenuItem value="Store">Store</MenuItem>
                            <MenuItem value="Shed">Shed</MenuItem>
                            <MenuItem value="Parking">Parking</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Description"
                            variant="outlined"
                            multiline
                            fullWidth
                            color="primary"
                            rows={6}
                            value={data?.description}
                            onChange={handleChange}
                            name="description"
                        />
                    </Grid>
                    {/* <Grid item xs={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={data.vacant}
                                    onChange={(e) =>
                                        setData({
                                            ...data,
                                            vacant: e.target.checked,
                                        })
                                    }
                                    name="vacant"
                                    color="primary"
                                />
                            }
                            label="Vacant"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={data.booked}
                                    onChange={(e) =>
                                        setData({
                                            ...data,
                                            booked: e.target.checked,
                                        })
                                    }
                                    name="booked"
                                    color="primary"
                                />
                            }
                            label="Booked"
                        />
                    </Grid> */}
                </Grid>

                <DialogActions>
                    {/* <Button
                        variant="contained"
                        onClick={onClose}
                        sx={{
                            color: theme.palette.primary,
                            backgroundColor: theme.palette.primary[800],
                        }}
                    >
                        Cancel
                    </Button> */}
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        {editMode ? "Update" : "Add"}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default AddFlatsForm;
